import { Box } from '@mui/material';
import { FormTitleBox } from '../../../common/components';
import HistoricalProgressFilters from './components/HistoricalProgressFilters';
import HistoricalProgressChart from './components/HistoricalProgressChart';
import { useHistoricalProgressDashboard } from './hooks/useHistoricalProgressDashboard';

const HistoricalProgressDashboard = () => {
  const { projects, selectedProject, timeline, entries, isLoading, handleProjectChange } =
    useHistoricalProgressDashboard();

  return (
    <Box>
      <FormTitleBox
        title="Obra | Seguimiento | Avance Histórico de Obra"
        showButton={false}
      />

      <HistoricalProgressFilters
        projects={projects}
        selectedProject={selectedProject}
        onProjectChange={handleProjectChange}
      />

      <HistoricalProgressChart timeline={timeline} entries={entries} isLoading={isLoading} />
    </Box>
  );
};

export default HistoricalProgressDashboard;
